import { render, staticRenderFns } from "./PathComponent.vue?vue&type=template&id=2f415fac&scoped=true"
import script from "./PathComponent.vue?vue&type=script&lang=js"
export * from "./PathComponent.vue?vue&type=script&lang=js"
import style0 from "./PathComponent.vue?vue&type=style&index=0&id=2f415fac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f415fac",
  null
  
)

export default component.exports